import { JBaseApi } from '../base';
import { ApiWrapper, BaseMessages, Filters, Orders, PagingResults, jDiapazoneList } from '../../types';
import { OF } from '../../util/network';

export class JDiapazoneApi extends JBaseApi {
    public create<T>(
        type: string,
        token: string,
        title: string,
        dateStart: string,
        publishTo: Array<string>,
    ): Promise<ApiWrapper<Array<T>, BaseMessages>> {
        return this.network.post({
            o: 'article',
            f: 'create',
            type,
            token,
            title,
            dateStart,
            publishTo,
        } as OF);
    }

    public getList(
        query = '',
        filters: Filters = [],
        orders: Orders = [],
        page = 1,
        format = 'raw-list',
    ): Promise<ApiWrapper<PagingResults<jDiapazoneList>>> {
        return this.network.post({
            o: 'objectList',
            f: 'diapazoneQueryList',
            query,
            filters,
            orders,
            page,
            format,
        } as OF);
    }
}
